import { ITab } from './costRevModels';

export const voyagesCols = [
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'vesselCode',
        fieldHeader: 'Vessel Code',
        isActionLink: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'vesselName',
        fieldHeader: 'Vessel Name',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'voyageNumber',
        fieldHeader: 'Voyage Number',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'loadingPortCode',
        fieldHeader: 'Port of Loading',
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'destinationPortCode',
        fieldHeader: `Port of Discharge`,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'etd',
        fieldHeader: 'ETD',
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        accessor: 'atd',
        fieldHeader: 'ATD',
        editable: false,
        show: true,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        accessor: 'eta',
        fieldHeader: 'ETA',
        show: true,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        accessor: 'ata',
        show: true,
        fieldHeader: 'ATA',
    },
    {
        headerClassName: 'data-table header',
        accessor: 'type',
        show: true,
        fieldHeader: 'Type',
    },
    {
        headerClassName: 'data-table header',
        accessor: 'voyageId',
        show: true,
        fieldHeader: 'Id',
    },
];
export const equipmentTransportShipmentsCols = [
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'equipmentTransportShipmentDocumentNumber',
        fieldHeader: 'Equipment Transport',
        isActionLink: true,
    },
    {
        headerClassName: 'data-table header fixedNumber',
        className: 'fixedNumber',
        show: true,
        accessor: 'equipmentNumber',
        fieldHeader: 'Equipment No.',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'equipmentSealNumber',
        fieldHeader: 'Equipment Seal No.',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'shipmentNumber',
        fieldHeader: 'Shipment No.',
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        className: 'totalQuantity -number',
        show: true,
        accessor: 'quantity',
        fieldHeader: 'Quantity',
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalWeight -number',
        show: true,
        accessor: 'weight',
        fieldHeader: 'Weight',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalVolume -number',
        show: true,
        accessor: 'volume',
        fieldHeader: 'Volume',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalPackages -number',
        show: true,
        accessor: 'packages',
        fieldHeader: 'Packages',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'createDate',
        fieldHeader: 'Creation Date',
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'lastUpdateDate',
        fieldHeader: 'Updated Date',
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'anyIssoSent',
        fieldHeader: 'ISSO Sent',
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'id',
        fieldHeader: 'ID',
        sortable: true,
    },
];

export const cblCols = [
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'number',
        fieldHeader: 'Number',
        isActionLink: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'opsStatus',
        fieldHeader: 'Status',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'internalNumber',
        fieldHeader: 'Internal No.',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'carrierBookingReference',
        fieldHeader: 'Carrier Booking Ref',
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        className: 'totalQuantity -number',
        show: true,
        accessor: 'quantity',
        fieldHeader: 'Quantity',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalWeight -number',
        show: true,
        accessor: 'weight',
        fieldHeader: 'Weight',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalVolume -number',
        show: true,
        accessor: 'volume',
        fieldHeader: 'Volume',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalPackages -number',
        show: true,
        accessor: 'packages',
        fieldHeader: 'Packages',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalEtVolume -number',
        show: true,
        accessor: 'essoCblOnEtVolumeFactor',
        fieldHeader: 'Esso CBL on Et Volume Factor',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        className: 'totalCblVolume -number',
        show: true,
        accessor: 'essoEtOnCblVolumeFactor',
        fieldHeader: 'Esso Et on CBL Volume Factor',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'transportContractNumber',
        fieldHeader: `Carrier Contract`,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'carrierCode',
        fieldHeader: 'Carrier',
        sortable: true,
    },
    {
        fieldHeader: 'Shipper',
        accessor: 'shipperName',
        headerClassName: 'data-table header',
        show: true,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'placeOfReceiptName',
        fieldHeader: 'Place of Receipt',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'originalPortOfLoadingName',
        fieldHeader: 'Port of Loading',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'finalPortOfDischargeName',
        fieldHeader: 'Port of Discharge',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'placeOfDeliveryName',
        fieldHeader: 'Place of Delivery',
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'createdDateTime',
        fieldHeader: 'Created Date',
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'updatedDateTime',
        fieldHeader: 'Updated Date',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'id',
        fieldHeader: 'ID',
        sortable: true,
        dataType: 'number',
    },
];

export const cblColsEts = JSON.parse(JSON.stringify(cblCols));
cblColsEts[8].fieldHeader = 'ETS CBL on Et Volume Factor';
cblColsEts[9].fieldHeader = 'ETS Et on CBL Volume Factor';

export const clrCols = [
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'clrNumber',
        fieldHeader: 'CLR Number',
        isActionLink: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'opsStatus',
        fieldHeader: 'Status',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalQuantity -number',
        show: true,
        accessor: 'quantity',
        fieldHeader: 'Quantity',
        footer: { label: '', type: 'sum' },
    },
    {
        headerClassName: 'data-table header',
        className: 'totalWeight -number',
        show: true,
        accessor: 'weight',
        fieldHeader: 'Weight',
        footer: { label: '', type: 'sum' },
    },
    {
        headerClassName: 'data-table header',
        className: 'totalVolume -number',
        show: true,
        accessor: 'volume',
        fieldHeader: 'Volume',
        footer: { label: '', type: 'sum' },
    },
    {
        headerClassName: 'data-table header',
        className: 'totalPackages -number',
        show: true,
        accessor: 'packages',
        fieldHeader: `Packages`,
        footer: { label: '', type: 'sum' },
    },
    {
        fieldHeader: 'Updated Date',
        accessor: 'updateDate',
        headerClassName: 'data-table header',
        show: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'clrId',
        fieldHeader: 'ID',
        sortable: true,
        dataType: 'number',
    },
];
export const equipmentCols = [
    {
        headerClassName: 'data-table header fixedNumber',
        className: 'fixedNumber',
        show: true,
        accessor: 'equipmentNumber',
        fieldHeader: 'Equipment No.',
        editable: false,
        isActionLink: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'sealNumber1',
        fieldHeader: 'Seal No.',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'equipmentType',
        fieldHeader: 'Type',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'equipmentSize',
        fieldHeader: `Size`,
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        className: 'totalQuantity -number',
        show: true,
        accessor: 'quantity',
        fieldHeader: 'Quantity',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalWeight -number',
        show: true,
        accessor: 'weight',
        fieldHeader: 'Weight',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalVolume -number',
        show: true,
        accessor: 'volume',
        fieldHeader: 'Volume',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalPackages -number',
        show: true,
        accessor: 'packages',
        fieldHeader: 'Packages',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalEqVolume -number',
        show: true,
        accessor: 'documentOnEquipmentVolume',
        fieldHeader: 'Document on Eq. Volume',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalEssoVolume -number',
        show: true,
        accessor: 'etOnEssoVolumeFactor',
        fieldHeader: 'Et on Esso Volume Factor',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'substitutionSize',
        fieldHeader: `Substitution Size`,
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'substitutionType',
        fieldHeader: `Substitution Type`,
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'opsStatus',
        fieldHeader: 'Status',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'insertDate',
        fieldHeader: 'Creation Date',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'updateDate',
        fieldHeader: 'Updated Date',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'equipmentId',
        fieldHeader: 'ID',
        sortable: true,
        dataType: 'number',
    },
];

export const equipmentColsForCBL = [
    {
        headerClassName: 'data-table header fixedNumber',
        className: 'fixedNumber',
        show: true,
        accessor: 'equipmentNumber',
        fieldHeader: 'Equipment No.',
        editable: false,
        isActionLink: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'sealNumber1',
        fieldHeader: 'Seal No.',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'equipmentType',
        fieldHeader: 'Type',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'equipmentSize',
        fieldHeader: `Size`,
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        className: 'totalQuantity -number',
        show: true,
        accessor: 'quantity',
        fieldHeader: 'Quantity',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalWeight -number',
        show: true,
        accessor: 'weight',
        fieldHeader: 'Weight',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalVolume -number',
        show: true,
        accessor: 'equipmentTotalVolume',
        fieldHeader: 'Volume',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalPackages -number',
        show: true,
        accessor: 'packages',
        fieldHeader: 'Packages',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalEqVolume -number',
        show: true,
        accessor: 'documentOnEquipmentVolume',
        fieldHeader: 'Document on Eq. Volume',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalEssoVolume -number',
        show: true,
        accessor: 'etOnEssoVolumeFactor',
        fieldHeader: 'Et on Esso Volume Factor',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'substitutionSize',
        fieldHeader: `Substitution Size`,
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'substitutionType',
        fieldHeader: `Substitution Type`,
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'opsStatus',
        fieldHeader: 'Status',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'insertDate',
        fieldHeader: 'Creation Date',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'updateDate',
        fieldHeader: 'Updated Date',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'equipmentId',
        fieldHeader: 'ID',
        sortable: true,
        dataType: 'number',
    },
];

export const equipmentColsDocs = [
    {
        headerClassName: 'data-table header fixedNumber',
        className: 'fixedNumber',
        show: true,
        accessor: 'equipmentNumber',
        fieldHeader: 'Equipment No.',
        editable: false,
        isActionLink: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'sealNumber',
        fieldHeader: 'Seal No.',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'type',
        fieldHeader: 'Type',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'size',
        fieldHeader: `Size`,
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalQuantity -number',
        show: true,
        accessor: 'quantity',
        fieldHeader: 'Quantity',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalWeight -number',
        show: true,
        accessor: 'weight',
        fieldHeader: 'Weight',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalVolume -number',
        show: true,
        accessor: 'volume',
        fieldHeader: 'Volume',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalPackages -number',
        show: true,
        accessor: 'packages',
        fieldHeader: 'Packages',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalEqVolume -number',
        show: true,
        accessor: 'documentOnEquipmentVolume',
        fieldHeader: 'Document on Eq. Volume',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalEssoVolume -number',
        show: true,
        accessor: 'etOnEssoVolumeFactor',
        fieldHeader: 'Et on Esso Volume Factor',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'subType',
        fieldHeader: `Substitute Type`,
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'subSize',
        fieldHeader: `Substitute Size`,
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'opsStatus',
        fieldHeader: 'Status',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'createDate',
        fieldHeader: 'Creation Date',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'updateDate',
        fieldHeader: 'Updated Date',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'equipmentId',
        fieldHeader: 'ID',
        sortable: true,
        dataType: 'number',
    },
];
export const equipmentColsEts = equipmentColsDocs.slice();
equipmentColsEts[8].fieldHeader = 'ETS on Eq. Volume';
equipmentColsEts[9].fieldHeader = 'Et on ETS Volume Factor';

export const bookingsCols = [
    {
        headerClassName: 'data-table header fixedNumber',
        className: 'fixedNumber',
        show: true,
        accessor: 'bookingNumber',
        fieldHeader: 'Booking',
        editable: false,
        isActionLink: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'status',
        fieldHeader: 'Status',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'serviceAtOrigin',
        fieldHeader: 'Origin Service',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'serviceAtDestination',
        fieldHeader: 'Destination Service',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        className: 'totalQuantity -number',
        show: true,
        accessor: 'quantity',
        fieldHeader: 'Quantity',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalWeight -number',
        show: true,
        accessor: 'weight',
        fieldHeader: 'Weight',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        className: 'totalVolume -number',
        show: true,
        accessor: 'volume',
        fieldHeader: 'Volume',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalPackages -number',
        show: true,
        accessor: 'packages',
        fieldHeader: 'Packages',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'placeOfReceiptName',
        fieldHeader: 'Place of Receipt',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'portOfLoadingName',
        fieldHeader: 'Port of Loading',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'portOfDischargeName',
        fieldHeader: 'Port of Discharge',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'placeOfDeliveryName',
        fieldHeader: 'Place of Delivery',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'isTransferred',
        fieldHeader: 'Tri-Trade',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'cargoReadyDate',
        fieldHeader: 'Cargo Ready Date',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'createdDateTime',
        fieldHeader: 'Created Date',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'updatedDateTime',
        fieldHeader: 'Last Updated Date',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'id',
        fieldHeader: 'ID',
        sortable: true,
        dataType: 'number',
    },
];

export const fcrCols = (isExtraDocumentFeatureEnabled = false, isNonBKSDocument = true, isHblConsumptionEnabled = false) => {
    return [
        {
            headerClassName: 'data-table header fixedNumber',
            className: 'fixedNumber',
            show: true,
            isActionLink: isNonBKSDocument,
            accessor: 'originalDocumentNumber',
            fieldHeader: isExtraDocumentFeatureEnabled
                ? 'Document Number'
                : (isHblConsumptionEnabled ? 'FCR/HBL No.' : 'FCR No.'),
            editable: false,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'type',
            fieldHeader: isExtraDocumentFeatureEnabled
                ? 'Document type'
                : (isHblConsumptionEnabled ? 'FCR/HBL type' : 'FCR type'),
            editable: false,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'shipmentType',
            fieldHeader: 'Shipment Type',
            editable: false,
            footer: null,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'originService',
            fieldHeader: 'Origin Service',
            editable: false,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'destinationService',
            fieldHeader: 'Destination Service',
            editable: false,
            footer: null,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            className: 'totalQuantity -number',
            show: true,
            accessor: 'quantity',
            fieldHeader: 'Quantity',
            editable: false,
            footer: { label: '', type: 'sum' },
            sortable: true,
            dataType: 'number',
        },
        {
            headerClassName: 'data-table header',
            className: 'totalWeight -number',
            show: true,
            accessor: 'weight',
            fieldHeader: 'Weight',
            editable: false,
            footer: { label: '', type: 'sum' },
            sortable: true,
            dataType: 'number',
        },
        {
            headerClassName: 'data-table header',
            className: 'totalVolume -number',
            show: true,
            accessor: 'volume',
            fieldHeader: 'Volume',
            editable: false,
            footer: { label: '', type: 'sum' },
            sortable: true,
            dataType: 'number',
        },
        {
            headerClassName: 'data-table header',
            className: 'totalPackages',
            show: true,
            accessor: 'packages',
            fieldHeader: 'Packages',
            editable: false,
            footer: { label: '', type: 'sum' },
            sortable: true,
            dataType: 'number',
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'opsStatus',
            fieldHeader: 'Status',
            editable: false,
            footer: null,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'finOpsStatus',
            fieldHeader: 'FinOps Status',
            editable: false,
            footer: null,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'deliveryTimeEstimated',
            fieldHeader: 'ETD',
            editable: false,
            footer: null,
            sortable: true,
            dataType: 'date',
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'placeOfReceiptName',
            fieldHeader: 'Place of Receipt',
            editable: false,
            footer: null,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'portOfLoadingName',
            fieldHeader: 'Port of Loading',
            editable: false,
            footer: null,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'portOfDischargeName',
            fieldHeader: 'Port of Discharge',
            editable: false,
            footer: null,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'placeOfDeliveryName',
            fieldHeader: 'Place of Delivery',
            editable: false,
            footer: null,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'insertDate',
            fieldHeader: 'Creation Date',
            editable: false,
            footer: null,
            sortable: true,
            dataType: 'date',
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'updateDate',
            fieldHeader: 'Updated Date',
            editable: false,
            footer: null,
            sortable: true,
            dataType: 'date',
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'id',
            fieldHeader: 'ID',
            sortable: true,
            dataType: 'number',
        },
    ];
};
export const documentCols = (isExtraDocumentFeatureEnabled = false, isHblConsumptionEnabled = false) => {
    return [
        {
            headerClassName: 'data-table header',
            show: true,
            isActionLink: true,
            accessor: 'fcrNumber',
            fieldHeader: isExtraDocumentFeatureEnabled
                ? 'Document Number'
                : (isHblConsumptionEnabled ? 'FCR/HBL No.' : 'FCR No.'),
            editable: false,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'opsStatus',
            fieldHeader: 'Status',
            editable: false,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'finOpsStatus',
            fieldHeader: 'FinOps Status',
            editable: false,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'fcrType',
            fieldHeader: isExtraDocumentFeatureEnabled
                ? 'Document type'
                : (isHblConsumptionEnabled ? 'FCR/HBL type' : 'FCR type'),
            editable: false,
        },
        {
            headerClassName: 'data-table header',
            className: 'totalQuantity -number',
            show: true,
            accessor: 'quantity',
            fieldHeader: 'Quantity',
            editable: false,
            footer: { label: '', type: 'sum' },
            sortable: true,
            dataType: 'number',
        },
        {
            headerClassName: 'data-table header',
            className: 'totalWeight -number',
            show: true,
            accessor: 'weight',
            fieldHeader: 'Weight',
            editable: false,
            footer: { label: '', type: 'sum' },
            sortable: true,
            dataType: 'number',
        },
        {
            headerClassName: 'data-table header',
            className: 'totalVolume -number',
            show: true,
            accessor: 'volume',
            fieldHeader: 'Volume',
            editable: false,
            footer: { label: '', type: 'sum' },
            sortable: true,
            dataType: 'number',
        },
        {
            headerClassName: 'data-table header',
            className: 'totalPackages -number',
            show: true,
            accessor: 'packages',
            fieldHeader: 'Packages',
            editable: false,
            footer: { label: '', type: 'sum' },
            sortable: true,
            dataType: 'number',
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'shipmentType',
            fieldHeader: 'Shipment Type',
            editable: false,
            footer: null,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'originService',
            fieldHeader: 'Origin Service',
            editable: false,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'destinationService',
            fieldHeader: 'Destination Service',
            editable: false,
            footer: null,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'etd',
            fieldHeader: 'ETD',
            editable: false,
            footer: null,
            sortable: true,
            dataType: 'date',
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'placeOfReceipt',
            fieldHeader: 'Place of Receipt',
            editable: false,
            footer: null,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'portOfLoading',
            fieldHeader: 'Port of Loading',
            editable: false,
            footer: null,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'portOfDischarge',
            fieldHeader: 'Port of Discharge',
            editable: false,
            footer: null,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'creationDate',
            fieldHeader: 'Creation Date',
            editable: false,
            footer: null,
            sortable: true,
            dataType: 'date',
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'updatedDate',
            fieldHeader: 'Updated Date',
            editable: false,
            footer: null,
            sortable: true,
            dataType: 'date',
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'documentId',
            fieldHeader: 'ID',
            sortable: true,
            dataType: 'number',
        },
    ];
};

export const equipmentDocumentCols = [
    {
        headerClassName: 'data-table header',
        show: true,
        isActionLink: true,
        accessor: 'originalDocumentNumber',
        fieldHeader: 'Document Number',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'opsStatus',
        fieldHeader: 'Status',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'finOpsStatus',
        fieldHeader: 'FinOps Status',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'type',
        fieldHeader: 'Document type',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        className: 'totalQuantity -number',
        show: true,
        accessor: 'quantity',
        fieldHeader: 'Quantity',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalWeight -number',
        show: true,
        accessor: 'weight',
        fieldHeader: 'Weight',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalVolume -number',
        show: true,
        accessor: 'volume',
        fieldHeader: 'Volume',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        className: 'totalPackages -number',
        show: true,
        accessor: 'packages',
        fieldHeader: 'Packages',
        editable: false,
        footer: { label: '', type: 'sum' },
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'shipmentType',
        fieldHeader: 'Shipment Type',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'originService',
        fieldHeader: 'Origin Service',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'destinationService',
        fieldHeader: 'Destination Service',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'etd',
        fieldHeader: 'ETD',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'placeOfReceipt',
        fieldHeader: 'Place of Receipt',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'portOfLoading',
        fieldHeader: 'Port of Loading',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'portOfDischarge',
        fieldHeader: 'Port of Discharge',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'creationDate',
        fieldHeader: 'Creation Date',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'updatedDate',
        fieldHeader: 'Updated Date',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'id',
        fieldHeader: 'ID',
        sortable: true,
        dataType: 'number',
    },
];

export const purchaseOrdersCols = [
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'purchaseOrderNumbers',
        fieldHeader: 'Purchase Order Numbers',
        editable: false,
    },
];

export const partnersCols = [
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'partnerType',
        fieldHeader: 'Party',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'country',
        fieldHeader: 'Country Code',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'beCode',
        fieldHeader: 'Business Entity Code',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'name',
        fieldHeader: 'Name',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'factCode',
        fieldHeader: 'FACT Code',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'scV_SCACCode',
        fieldHeader: 'SCV Code',
        editable: false,
        sortable: true,
    },
];

export const salesOrdersCols = (isSAPJobCloseNotification = false, hideSalesOrderNumber = false) => {
    return [
        {
            headerClassName: 'data-table header',
            show: !hideSalesOrderNumber,
            accessor: 'salesOrderNumber',
            fieldHeader: 'Sales Order Number',
            editable: false,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'finNumber',
            fieldHeader: 'Fin Number',
            editable: false,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'finOpsStatusNew',
            fieldHeader: 'FinOps Status',
            editable: false,
            footer: null,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'triggeredByDocumentNumber',
            fieldHeader: 'Trigger Document',
            editable: false,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'triggeredByDocumentType',
            fieldHeader: 'Document Type',
            editable: false,
            footer: null,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'lastUpdatedDate',
            fieldHeader: 'Last Updated Date',
            editable: false,
            sortable: true,
            dataType: 'date',
        },
        {
            headerClassName: 'data-table header',
            show: isSAPJobCloseNotification,
            accessor: 'tentativeCloseDate',
            fieldHeader: 'Estimated Job Close Date',
            editable: false,
            sortable: true,
            dataType: 'date',
        },
        {
            headerClassName: 'data-table header',
            show: isSAPJobCloseNotification,
            accessor: 'isClosedForUI',
            fieldHeader: 'Job Close Status',
            editable: false,
            sortable: false,
        },
        {
            headerClassName: 'data-table header',
            show: isSAPJobCloseNotification,
            accessor: 'reopenDate',
            fieldHeader: 'Job Reopened Date',
            editable: false,
            sortable: false,
        },
    ];
};

export const customerInvoiceCols = [
    {
        headerClassName: 'data-table header fixedNumber-xl',
        className: 'fixedNumber-xl',
        show: true,
        accessor: 'internalBillingNo',
        fieldHeader: 'Internal Invoice No.',
        editable: false,
        isActionLink: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'billingType',
        fieldHeader: 'Invoice Type',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'sapBillingNo',
        fieldHeader: 'SAP Invoice N0.',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'totalAmount',
        fieldHeader: 'Total Amount',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'billingCurrency',
        fieldHeader: `Invoice Currency`,
        editable: false,

        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'createdBy',
        fieldHeader: `Created By`,
        editable: false,

        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'createdDate',
        fieldHeader: 'Created Date',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'billingDate',
        fieldHeader: 'Invoice Date',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'billToParty',
        fieldHeader: 'Bill-to-Party',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'accountingStatus',
        fieldHeader: 'Invoice Status',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'invoicesId',
        fieldHeader: 'ID',
        sortable: true,
    },
];

export const customerInvoiceExportJobCols = [
    {
        headerClassName: 'data-table header fixedNumber-xl',
        className: 'fixedNumber-xl',
        show: true,
        accessor: 'internalBillingNumber',
        fieldHeader: 'Internal Invoice No.',
        editable: false,
        isActionLink: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'billingType',
        fieldHeader: 'Invoice Type',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'sapBillingNumber',
        fieldHeader: 'SAP Invoice N0.',
        editable: false,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'totalAmount',
        fieldHeader: 'Total Amount',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'number',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'billingCurrency',
        fieldHeader: `Invoice Currency`,
        editable: false,

        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'createdBy',
        fieldHeader: `Created By`,
        editable: false,

        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'createdDate',
        fieldHeader: 'Created Date',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'billingDate',
        fieldHeader: 'Invoice Date',
        editable: false,
        footer: null,
        sortable: true,
        dataType: 'date',
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'billToParty',
        fieldHeader: 'Bill-to-Party',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'invoiceStatus',
        fieldHeader: 'Invoice Status',
        editable: false,
        footer: null,
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'invoicesId',
        fieldHeader: 'ID',
        sortable: true,
    },
];

export const historyLogCols = [
    {
        fieldHeader: 'Action',
        accessor: 'action',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Description',
        accessor: 'description',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Status',
        accessor: 'status',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Source',
        accessor: 'source',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Destination',
        accessor: 'destination',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Message Type',
        accessor: 'messageType',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'By',
        accessor: 'userId',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Date / Time',
        accessor: 'generatedTimestamp',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
        dataType: 'date',
    },
    {
        fieldHeader: 'Message Details',
        accessor: 'messageDetails',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        isActionLink: true,
        sortable: true,
    },
    {
        fieldHeader: 'ID',
        accessor: 'id',
        headerClassName: 'data-table header',
        show: true,
        sortable: true,
        dataType: 'number',
    },
];
export const historyLogRevenueCols = (isSourceAthena = false, enableBlockedType = false, isNftpBillable = false) => {
    return [
        {
            fieldHeader: 'Charge Item',
            accessor: 'chargeItem',
            headerClassName: 'data-table header fixedNumber',
            className: 'fixedNumber',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Description',
            accessor: 'chargeDescription',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Item No.',
            accessor: 'itemNumber',
            headerClassName: 'data-table header',
            show: !isNftpBillable,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Action',
            accessor: 'action',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Status',
            accessor: 'status',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'UoM',
            accessor: 'uom',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Rate',
            accessor: 'rate',
            className: '-number',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
            dataType: 'number',
        },
        {
            fieldHeader: 'QTY',
            accessor: 'quantity',
            className: '-number',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
            dataType: 'number',
        },
        {
            fieldHeader: 'Currency',
            accessor: 'condCurrency',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Bill-to-Party',
            accessor: 'party',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            headerClassName: 'data-table header',
            show: true,
            accessor: 'serviceProvider',
            fieldHeader: 'Service Provider',
            editable: false,
            footer: null,
            sortable: true,
        },
        {
            fieldHeader: 'VAT Partner',
            accessor: 'vatPartner',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'ICB',
            accessor: 'icbIndicator',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Block Type',
            accessor: 'blockedType',
            headerClassName: 'data-table header',
            show: enableBlockedType,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Date / Time',
            accessor: 'actionDateTime',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
            dataType: 'date',
        },
        {
            fieldHeader: 'By',
            accessor: 'changedBy',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
            dataType: 'date',
        },
        {
            fieldHeader: 'Rate Details ID',
            accessor: 'rateDetailId',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Rate Identifier',
            accessor: 'athenaRateIdentifier',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Secondary Rate Identifier',
            accessor: 'athenaSecondaryRateIdentifier',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Reason Code',
            accessor: 'reasonDescription',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Service rendered',
            accessor: 'serviceRenderedAt',
            headerClassName: 'data-table header',
            show: isSourceAthena,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Pass Through',
            accessor: 'passThrough',
            headerClassName: 'data-table header',
            show: isSourceAthena,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Charge Type',
            accessor: 'chargeType',
            headerClassName: 'data-table header',
            show: isSourceAthena,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Dynamic Fields',
            accessor: 'dynamicFields',
            headerClassName: 'data-table header',
            show: isSourceAthena,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Applicability',
            accessor: 'applicability',
            headerClassName: 'data-table header',
            show: isSourceAthena,
            editable: false,
            sortable: true,
        },
    ];
};
export const historyLogCostCols = (isSourceAthena = false, enableBlockedType = false, isNftpBillable = false) => {
    return [
        {
            fieldHeader: 'Charge Item',
            accessor: 'chargeItem',
            headerClassName: 'data-table header fixedNumber',
            className: 'fixedNumber',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Description',
            accessor: 'chargeDescription',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Item No.',
            accessor: 'itemNumber',
            headerClassName: 'data-table header',
            show: !isNftpBillable,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Action',
            accessor: 'action',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Status',
            accessor: 'status',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'UoM',
            accessor: 'uom',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Rate',
            accessor: 'rate',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
            dataType: 'number',
        },
        {
            fieldHeader: 'QTY',
            accessor: 'quantity',
            className: '-number',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
            dataType: 'number',
        },
        {
            fieldHeader: 'Currency',
            accessor: 'condCurrency',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Pay-to-Party',
            accessor: 'party',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'ICB',
            accessor: 'icbIndicator',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Block Type',
            accessor: 'blockedType',
            headerClassName: 'data-table header',
            show: enableBlockedType,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Date / Time',
            accessor: 'actionDateTime',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
            dataType: 'date',
        },
        {
            fieldHeader: 'By',
            accessor: 'changedBy',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Rate Details ID',
            accessor: 'rateDetailId',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Rate Identifier',
            accessor: 'athenaRateIdentifier',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Secondary Rate Identifier',
            accessor: 'athenaSecondaryRateIdentifier',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Reason Code',
            accessor: 'reasonDescription',
            headerClassName: 'data-table header',
            show: true,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Service rendered',
            accessor: 'serviceRenderedAt',
            headerClassName: 'data-table header',
            show: isSourceAthena,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Pass Through',
            accessor: 'passThrough',
            headerClassName: 'data-table header',
            show: isSourceAthena,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Charge Type',
            accessor: 'chargeType',
            headerClassName: 'data-table header',
            show: isSourceAthena,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Dynamic Fields',
            accessor: 'dynamicFields',
            headerClassName: 'data-table header',
            show: isSourceAthena,
            editable: false,
            sortable: true,
        },
        {
            fieldHeader: 'Applicability',
            accessor: 'applicability',
            headerClassName: 'data-table header',
            show: isSourceAthena,
            editable: false,
            sortable: true,
        },
    ];
};
export const invoiceLogsCols = [
    {
        fieldHeader: 'Action',
        accessor: 'action',
        headerClassName: 'data-table header fixedNumber',
        className: 'fixedNumber',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Description',
        accessor: 'description',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Created By',
        accessor: 'by',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Date / Time',
        accessor: 'generatedTimestamp',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
        dataType: 'date',
    },
];

export const navLinksBooking: ITab[] = [
    {
        id: 1,
        title: 'Charges',
        emptyLabel: 'Charges are not available',
    },
    {
        id: 2,
        title: 'Booking details',
        emptyLabel: 'Booking details is not available',
    },
    {
        id: 3,
        title: 'View Partners',
        emptyLabel: 'Partners is not available',
    },
    {
        id: 4,
        title: 'History',
        emptyLabel: 'History is in development',
    },
];
export const navLinksFCR = (isExtraDocumentFeatureEnabled = false, isHblConsumptionEnabled = false): ITab[] => {
    return [
        {
            id: 1,
            title: 'Charges',
            emptyLabel: 'No Charges found',
        },
        {
            id: 2,
            title: isExtraDocumentFeatureEnabled
                ? 'Document details'
                : (isHblConsumptionEnabled ? 'FCR/HBL details' : 'FCR details'),
            emptyLabel: isExtraDocumentFeatureEnabled
                ? 'Document details is in development'
                : (isHblConsumptionEnabled ? 'FCR/HBL details is in development' : 'FCR details is in development'),
        },
        {
            id: 3,
            title: 'View Partners',
            emptyLabel: 'Partners is not available',
        },
        {
            id: 4,
            title: 'History',
            emptyLabel: 'History is in development',
        },
    ];
};
export const navLinksExportJob = (
    hideSalesOrders: boolean = false,
    salesOrdersTitle: string = 'Sales Orders',
): ITab[] => {
    let id = 1;

    const tabs: ITab[] = [
        {
            id: id++,
            title: 'Charges',
            emptyLabel: 'No Charges found',
        },
    ];

    if (!hideSalesOrders) {
        tabs.push({
            id: id++,
            title: salesOrdersTitle,
            emptyLabel: 'Sales Orders is in development',
        });
    }

    tabs.push(
        {
            id: id++,
            title: 'Export Job details',
            emptyLabel: 'Export Job details is in development',
        },
        {
            id: id++,
            title: 'View Partners',
            emptyLabel: 'Partners is not available',
        },
        {
            id: id++,
            title: 'History',
            emptyLabel: 'History is in development',
        },
    );

    return tabs;
};
export const navLinksETS: ITab[] = [
    {
        id: 1,
        title: 'Charges',
        emptyLabel: 'No Charges found',
    },
    {
        id: 2,
        title: 'ETS details',
        emptyLabel: 'ETS details is in development',
    },
    {
        id: 3,
        title: 'View Partners',
        emptyLabel: 'Partners is not available',
    },
    {
        id: 4,
        title: 'History',
        emptyLabel: 'History is in development',
    },
];
export const navLinksCBL: ITab[] = [
    {
        id: 1,
        title: 'Charges',
        emptyLabel: 'No Charges found',
    },
    {
        id: 2,
        title: 'CBL details',
        emptyLabel: 'CBL details is in development',
    },
    {
        id: 3,
        title: 'View Partners',
        emptyLabel: 'Partners is not available',
    },
    {
        id: 4,
        title: 'History',
        emptyLabel: 'History is in development',
    },
];

export const navLinksEquipment: ITab[] = [
    {
        id: 1,
        title: 'Charges',
        emptyLabel: 'No Charges found',
    },
    {
        id: 2,
        title: 'Equipment/CLR details',
        emptyLabel: 'Equipment/CLR details is in development',
    },
    {
        id: 3,
        title: 'History',
        emptyLabel: 'History is in development',
    },
];
export const switchTables = [
    {
        id: 1,
        title: 'Combined Revenue/Cost Table',
    },
    {
        id: 2,
        title: 'Divided Revenue/Cost Table',
    },
];
export const TAB_INVOICES = [
    {
        id: 1,
        title: 'Invoice details',
        emptyLabel: '',
    },
    {
        id: 2,
        title: 'History',
        emptyLabel: '',
    },
];
export const fcrForInvoices = [
    {
        fieldHeader: 'Document Number',
        accessor: 'documentnoWithFin',
        headerClassName: 'data-table header',
        isActionLink: true,
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'FinOps Status',
        accessor: 'status',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Type',
        accessor: 'type',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Sales Order Number',
        accessor: 'salesOrderNumberAndSalesOrderItem',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Consignee',
        accessor: 'consignee',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Carrier',
        accessor: 'carrier',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'ETD',
        accessor: 'etd',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
        dataType: 'date',
    },
    {
        fieldHeader: 'Place of Receipt',
        accessor: 'por',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Port of Loading',
        accessor: 'pol',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Port of discharge',
        accessor: 'pod',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Place of Delivery',
        accessor: 'placeOfDelivery',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'ID',
        accessor: 'documentId',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
];
export const etsForInvoices = [
    {
        fieldHeader: 'ETS Number',
        accessor: 'documentNumber',
        headerClassName: 'data-table header',
        isActionLink: true,
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'FinOps Status',
        accessor: 'status',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Sales Order Number',
        accessor: 'salesOrderNumberAndSalesOrderItem',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Consignee',
        accessor: 'consignee',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Carrier',
        accessor: 'carrier',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'ETD',
        accessor: 'etd',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
        dataType: 'date',
    },
    {
        fieldHeader: 'Place of Receipt',
        accessor: 'placeOfReceiptName',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Port of Loading',
        accessor: 'portOfLoadingName',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Port of discharge',
        accessor: 'portOfDischargeName',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'Place of Delivery',
        accessor: 'placeOfDeliveryName',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
    {
        fieldHeader: 'ID',
        accessor: 'equipmentTransportShipmentId',
        headerClassName: 'data-table header',
        show: true,
        editable: false,
        sortable: true,
    },
];